import { useEffect, useMemo } from "react";
import { useRawTable } from "../../hooks";

export default function Module_HealthAnalysisManagement_Table34({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        {
          key: "aa",
          field: "aa",
          header: "公司",
        },
        {
          key: "bb",
          field: "bb",
          header: "集團",
        },
        {
          key: "cc",
          field: "cc",
          header: "投控",
        },
        {
          key: "dd",
          field: "dd",
          header: "連展",
        },
        {
          key: "ee",
          field: "ee",
          header: "連訊",
        },
        {
          key: "ff",
          field: "ff",
          header: "連騰",
        },
        {
          key: "gg",
          field: "gg",
          header: "連淨",
        },
        {
          key: "hh",
          field: "hh",
          header: "電能",
        },
      ],
    }),
    [moduleData]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    let formatData = {
      健檢人數: {
        aa: "健檢人數",
        bb: 21,
        cc: 78,
        dd: 47,
        ee: 85,
        ff: 39,
        gg: 10,
        hh: 280,
      },
      異常人數: {
        aa: "異常人數",
        bb: 8,
        cc: 33,
        dd: 19,
        ee: 39,
        ff: 18,
        gg: 4,
        hh: 121,
      },
      四級人數: {
        aa: "四級人數",
        bb: 2,
        cc: 13,
        dd: 4,
        ee: 11,
        ff: 5,
        gg: 0,
        hh: 35,
        className: "text-red-400",
      },
      三級人數: {
        aa: "三級人數",
        bb: 6,
        cc: 20,
        dd: 15,
        ee: 28,
        ff: 13,
        gg: 4,
        hh: 89,
      },
      已諮詢: {
        aa: "已諮詢",
        bb: 7,
        cc: 30,
        dd: 14,
        ee: 30,
        ff: 7,
        gg: 4,
        hh: 92,
        className: "bg-purple-100",
      },
      自行追蹤: {
        aa: "自行追蹤",
        bb: 1,
        cc: 3,
        dd: 0,
        ee: 0,
        ff: 0,
        gg: 0,
        hh: 4,
      },
      已離職: {
        aa: "已離職",
        bb: 0,
        cc: 0,
        dd: 0,
        ee: 3,
        ff: 1,
        gg: 0,
        hh: 4,
      },
    };

    const calMinus = (keys = [], nowKey) => {
      let value = formatData[keys[0]][nowKey] - formatData[keys[1]][nowKey];

      return value;
    };

    const calAdd = (keys = [], nowKey) => {
      let value = keys.reduce((pre, key) => pre + formatData[key][nowKey], 0);

      return value;
    };

    const calPercent = (childKey, momKey, nowKey) => {
      const childVal = formatData[childKey][nowKey],
        momVal = formatData[momKey][nowKey];

      return childVal && momVal
        ? `${((childVal * 100) / momVal).toFixed(0)}%`
        : "0%";
    };

    formatData = {
      ...formatData,
      正常人數: {
        aa: "正常人數",
        bb: calMinus(["健檢人數", "異常人數"], "bb"),
        cc: calMinus(["健檢人數", "異常人數"], "cc"),
        dd: calMinus(["健檢人數", "異常人數"], "dd"),
        ee: calMinus(["健檢人數", "異常人數"], "ee"),
        ff: calMinus(["健檢人數", "異常人數"], "ff"),
        gg: calMinus(["健檢人數", "異常人數"], "gg"),
        hh: calMinus(["健檢人數", "異常人數"], "hh"),
      },
      已追蹤: {
        aa: "已追蹤",
        bb: calAdd(["已諮詢", "自行追蹤", "已離職"], "bb"),
        cc: calAdd(["已諮詢", "自行追蹤", "已離職"], "cc"),
        dd: calAdd(["已諮詢", "自行追蹤", "已離職"], "dd"),
        ee: calAdd(["已諮詢", "自行追蹤", "已離職"], "ee"),
        ff: calAdd(["已諮詢", "自行追蹤", "已離職"], "ff"),
        gg: calAdd(["已諮詢", "自行追蹤", "已離職"], "gg"),
        hh: calAdd(["已諮詢", "自行追蹤", "已離職"], "hh"),
        className: "bg-red-100",
      },
    };

    formatData = {
      ...formatData,
      健康指數: {
        aa: "健康指數",
        bb: calPercent("正常人數", "健檢人數", "bb"),
        cc: calPercent("正常人數", "健檢人數", "cc"),
        dd: calPercent("正常人數", "健檢人數", "dd"),
        ee: calPercent("正常人數", "健檢人數", "ee"),
        ff: calPercent("正常人數", "健檢人數", "ff"),
        gg: calPercent("正常人數", "健檢人數", "gg"),
        hh: calPercent("正常人數", "健檢人數", "hh"),
        className: "bg-orange-100",
      },
      諮詢: {
        aa: "諮詢%",
        bb: calPercent("已追蹤", "異常人數", "bb"),
        cc: calPercent("已追蹤", "異常人數", "cc"),
        dd: calPercent("已追蹤", "異常人數", "dd"),
        ee: calPercent("已追蹤", "異常人數", "ee"),
        ff: calPercent("已追蹤", "異常人數", "ff"),
        gg: calPercent("已追蹤", "異常人數", "gg"),
        hh: calPercent("已追蹤", "異常人數", "hh"),
        className: "text-blue-400",
      },
      跟進: {
        aa: "跟進%",
        bb: calPercent("已追蹤", "異常人數", "bb"),
        cc: calPercent("已追蹤", "異常人數", "cc"),
        dd: calPercent("已追蹤", "異常人數", "dd"),
        ee: calPercent("已追蹤", "異常人數", "ee"),
        ff: calPercent("已追蹤", "異常人數", "ff"),
        gg: calPercent("已追蹤", "異常人數", "gg"),
        hh: calPercent("已追蹤", "異常人數", "hh"),
      },
    };

    let finalData = [
      formatData["健檢人數"],
      formatData["異常人數"],
      formatData["健康指數"],
      formatData["四級人數"],
      formatData["三級人數"],
      formatData["已諮詢"],
      formatData["自行追蹤"],
      formatData["已離職"],
      formatData["諮詢"],
      formatData["已追蹤"],
      formatData["跟進"],
    ];

    setTbData({
      raw: finalData,
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
